import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authModal, setAuthModal] = useState(null); // 'signin' | 'signup' | 'reset' | null
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dscr_token");
    if (token) {
      authApi.me().then(setUser).catch(() => {
        localStorage.removeItem("dscr_token");
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const persist = (data) => {
    if (data?.token) localStorage.setItem("dscr_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const data = await authApi.login(email, password);
    setAuthModal(null);
    return persist(data);
  };

  const signup = async (payload) => {
    const data = await authApi.register(payload);
    setAuthModal(null);
    return persist(data);
  };

  const logout = () => {
    localStorage.removeItem("dscr_token");
    setUser(null);
  };

  const forgotPassword = (email) => authApi.forgotPassword(email);
  const resetPassword = (token, password) => authApi.resetPassword(token, password);
  const loginWithGoogle = async (sessionId) => {
    const data = await authApi.googleSession(sessionId);
    setAuthModal(null);
    return persist(data);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, authModal, setAuthModal, login, signup, logout, loading, forgotPassword, resetPassword, loginWithGoogle }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
